import React from 'react'
import { Badge } from 'antd'

import './ActionButton.css'

const ActionButton = ({
  children,
  onClick,
  className,
  disabled,
  isHighlight,
  notificationCount = 0,
  icon
}) => {
  return (
    <Badge
      count={notificationCount}
      color={'black'}
      className='action-button-badge'
    >
      <div
        className={`action-button ${className}`}
        onClick={onClick}
        data-disabled={disabled}
        data-highlight={isHighlight && !disabled}
      >
        {icon && <i className={`icon ${icon}`} />}
        {children}
      </div>
    </Badge>
  )
}

export default ActionButton
